var React   = require("react");
var Tabs    = require("../../components/tabs");
var StageFilters = require('./stage_filters');

var StageFilterSection = React.createClass({
  PropTypes: {
    challengeTypes: React.PropTypes.array.isRequired,
    selectedTabIndex: React.PropTypes.number.isRequired,
    onTabChange: React.PropTypes.func.isRequired,
    challengeStages : React.PropTypes.array.isRequired
  },

  render : function(){
    const { onTabChange, selectedTabIndex, challengeStages,
      selectedChallengeFilter, challengeTypes } = this.props;

    return (
      <div className="stage-filters">
        <div className="stage-filters__desktop">
          <Tabs onTabSelect={this._onTabSelect} options={this._getTabOptions(challengeStages)} />
        </div>
        <div className="stage-filters__tablet-and-mobile pt-override">
          <StageFilters
            onFilterChange={onTabChange}
            selectedFilterIndex={selectedTabIndex}
            challengeStages={challengeStages}/>
        </div>
      </div>
    );
  },

  _mapTab: function({ title }, i) {
    return {
      label: title,
      value: i,
      isSelected: this.props.selectedTabIndex === i,
      id: `challenge-stage-${title.toLowerCase()}`
    };
  },

  _getTabOptions: function(challengeStages) {
    return challengeStages.map(this._mapTab, this);
  },

  _onTabSelect: function(selectedTab) {
    this.props.onTabChange(this.props.challengeStages[selectedTab].action, selectedTab);
  },
});

module.exports = StageFilterSection;



// WEBPACK FOOTER //
// ./src/advocate/challenges/components/stage_filter_section.jsx